<template>
  <div class="hm-rating-input">
    <span
      v-for="n in 5"
      :key="n"
      @click="$emit('input', n)"
      class="rating"
      :class="{
        selected: n <= rating,
      }"
      v-tooltip="{
        content: rateText[n - 1],
        delay: 100,
        placement: 'top',
        container: 'body',
      }"
    >
      <i class="fa selected-icon" :class="selectedIconClass"></i>
      <i class="fa unselected-icon" :class="unselectedIconClass"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'HMRatingInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    iconType: {
      type: String,
      default: 'stars',
    },
  },
  data() {
    return {
      rateText: [
        this.$t('GENERAL.LABEL.VERY_DISAPPOINTED'),
        this.$t('GENERAL.LABEL.DISAPPOINTED'),
        this.$t('GENERAL.LABEL.NEUTRAL'),
        this.$t('GENERAL.LABEL.SATISFIED'),
        this.$t('GENERAL.LABEL.VERY_SATISFIED'),
      ],
    };
  },
  computed: {
    rating() {
      return this.value;
    },
    selectedIconClass() {
      const icons = {
        stars: 'fa-star',
        hearts: 'fa-heart',
        circles: 'fa-circle',
      };
      return icons[this.iconType];
    },
    unselectedIconClass() {
      const icons = {
        stars: 'fa-star-o',
        hearts: 'fa-heart-o',
        circles: 'fa-circle-o',
      };
      return icons[this.iconType];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/web/styles/components-variables.scss';

.rating {
  font-size: 28px;
  line-height: 30px;
  cursor: pointer;
  color: var(--brand-color, $coral);
  padding: 0 0.25rem;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
}

.hm-rating-input .rating.selected {
  .selected-icon {
    display: inline-block;
  }
  .unselected-icon {
    display: none;
  }
}

.hm-rating-input .rating {
  .selected-icon {
    display: none;
  }
  .unselected-icon {
    display: inline-block;
  }
}

.hm-rating-input:hover .rating {
  .selected-icon {
    display: inline-block;
  }
  .unselected-icon {
    display: none;
  }
}

.hm-rating-input .rating:hover ~ .rating {
  .selected-icon {
    display: none;
  }
  .unselected-icon {
    display: inline-block;
  }
}
</style>
